<template>
  <div class="StaffManage-list">
    <GlobalInfoBar
      title="门店标签管理"
      content="添加/管理门店标签，关联对应门店"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <GlobalForm
          class="global-form"
          :init-data="initData"
          :form-item-list="formItemList"
          :inline="true"
          :labelWidth="100"
          :needBtnLoading="true"
          round
          @handleConfirm="handleConfirm"
          confirmBtnName="查询"
        >
          <el-button
            icon="el-icon-plus"
            slot="AddSlot"
            type="primary"
            @click="addTagFn('add')"
            >添加标签</el-button
          >
        </GlobalForm>
      </div>
      <!-- <StaffManageTable /> -->
      <GlobalTable
        ref="GlobalTable"
        v-loading="loading"
        :columns="tagColumns"
        :data="tableData"
        :currentPage="page.pageNum"
        :pageSize="page.pageSize"
        :total="page.total"
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column label="关联门店" slot="storeNum" align="center">
          <template slot-scope="{ row }">
            <span
              :class="[row.storeNum ? 'storeNum' : '']"
              @click="storeNum(row)"
              >{{ row.storeNum ? row.storeNum : "--" }}</span
            >
            <span class="storeNum" style="margin-left:20px" @click="addStore(row)">添加</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="addTagFn('edit', row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="delFun(row,'tag')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog
      title="提示"
      :visible.sync="delTag"
      :close-on-click-modal="false"
      width="400px"
      @closed="delbtnclose"
    >
      <div class="delcen2txt" v-if="delType=='tag'">说明：删除后，将移除与标签关联的所有门店。</div>
      <div class="deltop1txt">{{delType=='tag'?'是否确认删除该门店标签？':'是否确认移除该门店吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="delbtnclose">取消</el-button>
        <el-button type="primary" @click="delsure" size="small">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="storeTagTitle"
      :visible.sync="addTagShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="closeDialogAddTag"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="门店标签" prop="tagName">
          <el-input
            v-model="ruleForm.tagName"
            placeholder="请输入门店标签，最多8个字"
            maxlength="8"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialogAddTag">取消</el-button>
        <el-button type="primary" @click="btngobox('ruleForm')" size="small"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <DialogTbale
      @onClose="storeNumClose"
      :show="storeNumVisible"
      title="门店列表"
      :loading="dialogLoading"
      :columns="DialogTableColumns"
      :data="DialogDataList"
      :width="1000"
      :currentPage="storePage.pageNum"
      :total="storePage.total"
      :pageSize="storePage.pageSize"
      @handleCurrentChange="handleCurrentChangeDialog"
    >
      <div class="flex" style="margin-bottom: 20px">
        <div class="flex item">
          <span style="width: 100px">门店名称：</span>
          <el-input
            v-model="storeName"
            size="small"
            placeholder="请输入门店名称"
            clearable
          ></el-input>
        </div>
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="searchStore"
        >
          查询
        </el-button>
      </div>
      <el-table-column label="区域/总监" slot="areaName" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.areaName && row.inspectorName">{{row.areaName}}-{{row.inspectorName}}</span>
          <span v-if="row.areaName && !row.inspectorName">{{row.areaName}}</span>
          <span v-if="!row.areaName && row.inspectorName">{{row.inspectorName}}</span>
          <span v-if="!row.areaName && !row.inspectorName">--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店店长" slot="storeManager" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeManager || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="店长联系方式"
        slot="storeManagerPhone"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.storeManagerPhone || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="danger" @click="delFun(row,'store')"
              >移除</el-button
            >
        </template>
      </el-table-column>
    </DialogTbale>
    <el-dialog
      title="添加门店"
      :visible.sync="addStoreShow"
      :close-on-click-modal="false"
      width="1000"
      @closed="closeDialogAddStore"
    >
      <div class="flex add-store-form" style="margin-bottom: 20px">
        <div class="flex item">
          <span style="width: 74px">区域/总监：</span>
          <el-select
            v-model="inspectorId"
            placeholder="请选择区域"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="item in inspectorAreaList"
              :key="item.staffId"
              :label="item.areaName
                  ? `${item.staffName}-${item.areaName}`
                  : item.staffName"
              :value="item.staffId"
            ></el-option>
          </el-select>
        </div>
        <div class="flex item">
          <span style="width: 100px">门店名称：</span>
          <el-input
            v-model="storeName"
            size="small"
            placeholder="请输入门店名称"
            clearable
          ></el-input>
        </div>
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="searchStore"
        >
          查询
        </el-button>
      </div>
      <GlobalTable
        v-loading="dialogLoading"
        class="mb-10"
        ref="multipleTable"
        myKey="addStore"
        :isPagination="true"
        :columns="addStoreColumns"
        :isIndex="true"
        :data="DialogDataList"
        :isSelection="true"
        judgeValue="id"
        :currentPage="storePage.pageNum"
        :pageSize="storePage.pageSize"
        :total="storePage.total"
        @handleCurrentChange="handleCurrentChangeDialog"
        @handleSelect="addStoreHandleSelect"
      >
        <el-table-column label="区域/总监" slot="areaName" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.areaName && row.inspectorName">{{row.areaName}}-{{row.inspectorName}}</span>
            <span v-if="row.areaName && !row.inspectorName">{{row.areaName}}</span>
            <span v-if="!row.areaName && row.inspectorName">{{row.inspectorName}}</span>
            <span v-if="!row.areaName && !row.inspectorName">--</span>
          </template>
        </el-table-column>
        <el-table-column label="门店店长" slot="storeManager" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.storeManager || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="店长联系方式"
          slot="storeManagerPhone"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.storeManagerPhone || "--" }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialogAddStore">取消</el-button>
        <el-button type="primary" @click="addStoreSure" size="small"
          >确定添加</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  components: {},
  data() {
    return {
      rowId: "", //标签ID
      ruleFormdata: [],
      inspectorAreaList: [],
      storeIdArr: [],
      operationType: "",
      delType: "",
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      storePage:{
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      storeNumVisible: false, //弹窗表格
      ruleForm: {
        tagName: "",
      },
      storeName: "",
      inspectorId: "",
      storeId: "",
      storeTagTitle: "",
      addTagShow: false, //新增标签
      delTag: false, //刪除标签
      addStoreShow: false,
      initData: null,
      loading: false,
      dialogLoading: false,
      searchData: {},
      //   select form data
      formItemList: [
        {
          key: "tagName",
          type: "input",
          labelName: "门店标签",
          placeholder: "请输入门店标签",
        },
      ],
      tagColumns: [
        { label: "门店标签", prop: "tagName" },
        { slotName: "storeNum" },
        { label: "创建时间", prop: "createTime" },
        { slotName: "operation" },
      ],
      tableData: [],

      DialogTableColumns: [
        { slotName: "areaName" },
        { label: "门店名称", prop: "storeName" },
        { slotName: "storeManager" },
        { slotName: "storeManagerPhone" },
        { slotName: "operation" },
      ],
      addStoreColumns: [
        { slotName: "areaName" },
        { label: "门店名称", prop: "storeName" },
        { slotName: "storeManager" },
        { slotName: "storeManagerPhone" },
      ],
      DialogDataList: [],
      rules: {
        tagName: [
          { required: true, message: "请输入门店标签名称", trigger: "blur" },
          { min: 0, max: 8, message: "最多输入8个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.handleCurrentChange(1);
    this.getNotPInspectorSelect()
  },
  mounted() {},
  methods: {
    handleConfirm(data,cd) {
      this.searchData = data;
      this.searchData.disuseLoding = () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      this.handleCurrentChange(1);
    },
    // list翻页方法
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      this.loading = true;
      let params = {
        tagName:
          this.searchData && this.searchData.tagName
            ? this.searchData.tagName
            : "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      _api.getStoreTagList(params).then((res) => {
        this.tableData = res.data.records;
        this.page.pageNum = res.data.current;
        this.page.total = res.data.total;
        this.loading = false;
        if (typeof this.searchData.disuseLoding === 'function') {
          this.searchData.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.searchData.disuseLoding === 'function') {
          this.searchData.disuseLoding();
        }
      });
    },
    handleCurrentChangeDialog(val) {
      if (val) {
        this.storePage.pageNum = val;
      }
      this.dialogLoading = true
      let params = {}
      if(this.storeNumVisible){
        params = {
          tagId: this.rowId,
          storeName: this.storeName,
          pageNum: this.storePage.pageNum,
          pageSize: this.storePage.pageSize,
        }
      }else{
        params = {
          storeName: this.storeName,
          inspectorId: this.inspectorId,
          pageNum: this.storePage.pageNum,
          pageSize: this.storePage.pageSize,
        }
      }
      _api
        .StaffManageList(params)
        .then((res) => {
          console.log(res, "门店数量");
          this.DialogDataList = res.data.records;
          this.storePage.pageNum = res.data.current;
          this.storePage.total = res.data.total;
          if(this.addStoreShow){
            let _rows = []
            this.DialogDataList.forEach(item => {
              this.storeIdArr.forEach(ele =>{
                if(item.id == ele){
                  _rows.push(item)
                }
              })
              return item
            })
            this.toggleSelection(_rows)
          }
          this.dialogLoading = false
        });
    },
    // 添加区域
    addTagFn(type, row) {
      this.operationType = type;
      if (type == "add") {
        this.storeTagTitle = "添加门店标签";
      } else {
        this.rowId = row.id;
        this.storeTagTitle = "编辑门店标签";
        this.ruleForm.tagName = row.tagName;
      }
      this.addTagShow = true;
    },
    // 删除方法
    delFun(row,type) {
      this.delType = type
      if(type == 'tag'){
        this.rowId = row.id;
      }else{
        this.storeId = row.id
      }
      this.delTag = true;
    },
    // 删除弹窗取消按钮
    delbtnclose() {
      this.delTag = false;
    },
    // 删除弹窗确定按钮
    delsure() {
      if(this.delType == 'tag') {
        _api.removeById({ tagId: this.rowId }).then((res) => {
          this.delTag = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          console.log(this.tableData.length);
          if (this.tableData.length == 1) {
            this.handleCurrentChange(1);
          } else {
            this.handleCurrentChange();
          }
        });
      }else{
        _api.removeByStore({ tagId: this.rowId ,storeId:this.storeId}).then((res) => {
          this.delTag = false;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          if (this.DialogDataList.length == 1) {
            this.handleCurrentChangeDialog(1);
          } else {
            this.handleCurrentChangeDialog();
          }
          this.handleCurrentChange();
        });
      }
      
    },
    // 添加弹窗取消按钮
    closeDialogAddTag() {
      this.addTagShow = false;
      this.ruleForm.tagName = "";
      this.rowId = "";
    },
    // 添加弹窗确定按钮
    btngobox(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            tagName: this.ruleForm.tagName,
            id: this.operationType == "edit" ? this.rowId : "",
          };
          _api.saveStoreTag(params).then((res) => {
            this.addTagShow = false;
            this.$message({
              message: this.operationType == "edit" ? "修改成功" : "添加成功",
              type: "success",
            });
            this.handleCurrentChange(1);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 门店数量点击
    storeNum(row) {
      this.rowId = row.id;
      this.storeNumVisible = true;
      this.handleCurrentChangeDialog(1)
    },
    searchStore() {
      this.handleCurrentChangeDialog(1)
    },
    // 门店数量弹窗关闭
    storeNumClose() {
      this.rowId = "";
      this.DialogDataList = []
      this.storeNumVisible = false;
    },
    getNotPInspectorSelect(){
      _api.getNotPInspectorSelect({ scope: "00" }).then((res) => {
        this.inspectorAreaList = res.data;
      });
    },
    // 添加门店弹框
    addStore(row) {
      this.rowId = row.id
      this.addStoreShow = true
      this.handleCurrentChangeDialog(1)
    },
    closeDialogAddStore() {
      this.addStoreShow = false
      this.DialogDataList = []
      this.storeIdArr = []
    },
    // 选择添加门店
    addStoreHandleSelect(e) {
      let arr = []
      e.forEach(item => {
        arr.push(item.id)
      });
      this.storeIdArr = this.storeIdArr.filter(item => {
				return !this.DialogDataList.some(ele => ele.id === item)
			})
      this.storeIdArr.push(...arr)
      console.log(this.storeIdArr);
    },
    // 回显显示效果
    toggleSelection(rows) {
      console.log(rows);
      Promise.resolve().then(() => {
        if (rows && rows.length) {
          rows.forEach((row) => {
            console.log(row);
            this.$refs.multipleTable.setSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 确定添加
    addStoreSure() {
      _api.saveRelation({tagId:this.rowId,storeIds:this.storeIdArr}).then(res => {
        this.$message.success('操作成功')
        this.addStoreShow = false
        this.handleCurrentChange();
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage-list {
  .button_top {
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn {
    width: 280px;
    height: 42px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      background: #0981ff;
      border-radius: 20px;
    }
    .right {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
}

.deltop1txt {
  text-align: center;
  font-size: 16px;
  margin: 20px 0;
}

.delcen2txt {
  color: #ff687b;
  font-size: 16px;
  margin-bottom: 20px;
}

.delbtn3 {
  padding: 40px 150px 20px 140px;
  display: flex;
  justify-content: space-between;
}

/deep/.elformitem {
  width: 360px;
}
/deep/.btnoutbox {
  width: 100%;
  //   display: flex;
  //   justify-content: space-between !important;

  margin-left: calc(50% - 75px);
  margin-bottom: 20px;
}
/deep/.btnclose {
  margin-left: 30px !important;
}

.storeNum {
  text-decoration: underline;
  cursor: pointer;
  color: #0981ff;
}
.add-store-form{
  .item{
    margin-right: 30px
  }
}
.flex {
  display: flex;
  align-items: center;
}
</style>
